<aside class="js-drawer-settings p-0 h-100 d-flex flex-column">
  <div class="offcanvas-header app-drawer-header">
    <div class="appearance-drawer-title mb-0">{{ i18n.t().appearance }}</div>
    <button
      type="button"
      class="btn btn-system ms-auto"
      data-testid="mindmap-appearance-close"
      [attr.aria-label]="i18n.t().close"
      (click)="close()"
    >
      <svg class="sa-icon sa-icon-2x">
        <use href="/assets/icons/sprite.svg#x"></use>
      </svg>
    </button>
  </div>

  <div class="offcanvas-body appearance-offcanvas-body">
    <section
      class="appearance-section"
      [attr.aria-label]="i18n.t().appearanceLayoutLabel"
    >
      <h5 class="appearance-section-title">
        {{ i18n.t().appearanceLayoutLabel }}
      </h5>
      <div
        class="appearance-layouts-grid"
        role="group"
        [attr.aria-label]="i18n.t().appearanceLayoutLabel"
      >
        @for (layout of layoutOptions; track layout.id) {
          <button
            type="button"
            class="appearance-card appearance-card--layout"
            [attr.data-testid]="'mindmap-appearance-layout-' + layout.id"
            [class.is-selected]="selectedLayout() === layout.id"
            [attr.aria-pressed]="selectedLayout() === layout.id"
            [attr.aria-label]="i18n.t()[layout.labelKey]"
            (click)="selectLayout(layout.id)"
          >
            <span class="appearance-card-icon" aria-hidden="true">
              @switch (layout.id) {
                @case ("mindmap") {
                  <svg viewBox="0 0 24 24">
                    <use href="/assets/icons/sprite.svg#icon-mode-map"></use>
                  </svg>
                }
                @case ("org-chart") {
                  <svg viewBox="0 0 24 24">
                    <use
                      href="/assets/icons/sprite.svg#appearance-card-icon"
                    ></use>
                  </svg>
                }
              }
            </span>
            <span class="appearance-card-label appearance-card-label--layout">{{
              i18n.t()[layout.labelKey]
            }}</span>
          </button>
        }
      </div>
    </section>

    <section
      class="appearance-section"
      [attr.aria-label]="i18n.t().appearanceThemesLabel"
    >
      <h5 class="appearance-section-title">
        {{ i18n.t().appearanceThemesLabel }}
      </h5>

      <div
        class="appearance-themes-grid"
        role="group"
        [attr.aria-label]="i18n.t().appearanceThemesLabel"
      >
        @for (theme of themeOptions; track theme.id) {
          <button
            type="button"
            class="appearance-card appearance-card--theme"
            [attr.data-testid]="'mindmap-appearance-theme-' + theme.id"
            [class.is-selected]="selectedTheme() === theme.id"
            [attr.aria-pressed]="selectedTheme() === theme.id"
            [attr.aria-label]="i18n.t()[theme.labelKey]"
            (click)="selectTheme(theme.id)"
          >
            <span
              class="appearance-card-icon appearance-card-icon--theme"
              aria-hidden="true"
            >
              @for (swatch of theme.swatches; track swatch) {
                <span class="theme-swatch" [style.--swatch]="swatch"></span>
              }
            </span>
            <span class="appearance-card-label appearance-card-label--theme">
              {{ i18n.t()[theme.labelKey] }}
            </span>
          </button>
        }
      </div>
    </section>
  </div>
</aside>
